var map = {
	"./GoSend.png": 9472,
	"./Icon-feather-map-pin@2x.png": 386,
	"./Iconawesome-user-circle.png": 5711,
	"./alert.png": 364,
	"./cart.png": 1866,
	"./cash.png": 5361,
	"./cashlez_icon.png": 7414,
	"./check.png": 8402,
	"./checked.png": 9349,
	"./chevron-down.png": 7630,
	"./disc_container.png": 2307,
	"./edit.png": 1044,
	"./en.png": 3657,
	"./failed.png": 2731,
	"./failed_payment.png": 8200,
	"./forget_pwd.png": 4263,
	"./free_delivery.png": 6963,
	"./icon-call.png": 5906,
	"./icon-feather-clock.png": 271,
	"./icon-sms.png": 8519,
	"./icon-wa.png": 2158,
	"./icon_box.png": 7673,
	"./icon_main.png": 5127,
	"./icon_motorcycle.png": 6507,
	"./icon_success.png": 2479,
	"./icon_warning.png": 7170,
	"./id.png": 71,
	"./indonesia.png": 6060,
	"./label_tag.png": 869,
	"./link_aja.png": 1455,
	"./max_radius.png": 2327,
	"./no_image_ritel.png": 9160,
	"./note.png": 3136,
	"./olsera_logo.png": 6210,
	"./payment_cod.png": 7695,
	"./payment_qris.png": 2860,
	"./pickup.png": 344,
	"./process.png": 1241,
	"./shipping.png": 6526,
	"./store.png": 5949,
	"./store_not_found.png": 8214,
	"./triangle_bottom.png": 7096,
	"./triangle_top.png": 7900,
	"./use_call.png": 584,
	"./use_message.png": 5791,
	"./use_whatsapp.png": 6894,
	"./voucher.png": 5180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8771;